/**
 * @readonly
 * @enum {string}
 */
export const CameraModels = {
    CAM_50: 'CAM 50',
    CAMPRO: 'CAM Pro',
    CAMLITE: 'CAM Lite'
}
